import { render, staticRenderFns } from "./taskLog.vue?vue&type=template&id=244d9552"
import script from "./taskLog.vue?vue&type=script&lang=js"
export * from "./taskLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('244d9552')) {
      api.createRecord('244d9552', component.options)
    } else {
      api.reload('244d9552', component.options)
    }
    module.hot.accept("./taskLog.vue?vue&type=template&id=244d9552", function () {
      api.rerender('244d9552', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/redBook/component/taskLog.vue"
export default component.exports